var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBbq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "BBQ",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.645,
    height: 101.683,
    viewBox: "0 0 74.645 101.683",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #2d3539;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    className: "cls-1",
    d: "M14.47,76.62a5.2,5.2,0,1,0,5.2,5.2,5.2,5.2,0,0,0-5.2-5.2Zm0,7.429A2.251,2.251,0,1,1,16.721,81.8,2.251,2.251,0,0,1,14.47,84.049Z",
    transform: "translate(1.121 9.623)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    className: "cls-1",
    d: "M26.79,16.015a1.486,1.486,0,0,0,2.972,0c0-1.418,2.386-1.868,2.386-4.851s-2.386-3.377-2.386-4.84,2.386-1.835,2.386-4.851a1.5,1.5,0,0,0-2.983,0c0,1.429-2.375,1.88-2.375,4.851s2.375,3.377,2.375,4.84S26.79,13.032,26.79,16.015Z",
    transform: "translate(3.322 0.013)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    className: "cls-1",
    d: "M18.82,16.015a1.486,1.486,0,0,0,2.972,0c0-1.418,2.386-1.868,2.386-4.851s-2.386-3.377-2.386-4.84,2.386-1.835,2.386-4.851a1.5,1.5,0,0,0-2.983,0c0,1.429-2.375,1.88-2.375,4.851s2.375,3.377,2.375,4.84S18.82,13.032,18.82,16.015Z",
    transform: "translate(2.321 0.013)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    className: "cls-1",
    d: "M34.75,16.028a1.5,1.5,0,0,0,2.983,0c0-1.418,2.375-1.868,2.375-4.851S37.733,7.8,37.733,6.337,40.108,4.5,40.108,1.486a1.486,1.486,0,1,0-2.972,0c0,1.429-2.386,1.88-2.386,4.851s2.386,3.377,2.386,4.84S34.75,13.046,34.75,16.028Z",
    transform: "translate(4.321)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    className: "cls-1",
    d: "M70.164,36.76H61.542V33.788a4.5,4.5,0,0,0-1.328-8.78h-8.07a36.514,36.514,0,0,0,0-3.872,3.377,3.377,0,0,0-3.377-3.377H16.879A3.377,3.377,0,0,0,13.5,21.137a36.75,36.75,0,0,0,0,3.872h-9a4.5,4.5,0,0,0-1.362,8.78c0,5.358-.473,11.47,3.624,18.887a1.486,1.486,0,0,0,2.6-1.441c-3.681-6.72-3.253-12.179-3.253-17.289H58.526c0,5.054.09,6.45-.428,9.309A26.226,26.226,0,0,1,13.221,56.492a1.493,1.493,0,0,0-2.161,2.06,28.624,28.624,0,0,0,6.45,5.155L13.93,79.172a10.209,10.209,0,1,0,8.915,2.87l.552-2.375H41.541l3.613,15.646a4.66,4.66,0,0,0,9.207-1.047,4.1,4.1,0,0,0-.124-1.047l-1.5-6.528a1.486,1.486,0,1,0-2.893.664l1.5,6.483a1.688,1.688,0,0,1-1.272,2.026A1.666,1.666,0,0,1,48.058,94.6L41.5,66.273a29.548,29.548,0,0,0,3.174-1.261l3.613,15.623a1.486,1.486,0,1,0,2.893-.675l-3.793-16.4A29.355,29.355,0,0,0,60.507,46.249h9.658a4.75,4.75,0,0,0,0-9.489Zm-43.9,30.391a29.265,29.265,0,0,0,6.044.63,29.659,29.659,0,0,0,6.281-.675l.844,3.669H25.467ZM15.63,96.427a7.215,7.215,0,1,1,7.2-7.215,7.215,7.215,0,0,1-7.2,7.215Zm6.247-23.435-1.126,4.84h0l-.529,2.251a10.513,10.513,0,0,0-3.23-1l3.264-13.957a29.514,29.514,0,0,0,3.185,1.227Zm2.251,3.692a27.126,27.126,0,0,0,.687-2.972H40.156c.574,2.5.416,1.8.687,2.972ZM16.451,21.137a.428.428,0,0,1,.428-.439H48.767a.428.428,0,0,1,.428.439v3.444a.428.428,0,0,1-.428.428H16.879a.428.428,0,0,1-.428-.428Zm43.605,9.826H4.5a1.5,1.5,0,0,1,0-2.983H60.214a1.5,1.5,0,1,1-.158,2.983Zm10.13,12.314h-9a29.569,29.569,0,0,0,.36-3.546h8.645a1.778,1.778,0,0,1,0,3.546Z",
    transform: "translate(-0.038 2.23)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbq);
export default __webpack_public_path__ + "static/media/BBQ.58ff733908d2975902556f10ebf816dc.svg";
export { ForwardRef as ReactComponent };